export default __webpack_public_path__ + "static/media/06.c749fd88.png";